import { PROJECTS_FULL_PAGE_SEARCH_PAGE, PROJECTS_FULL_PAGE_SEARCH_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const projectsAppGlobalSearchRoute: GlobalHomePageRoute = createGlobalRoute({
	layout: 'home',
	nav4Layout: 'expanded',
	exact: true,
	name: PROJECTS_FULL_PAGE_SEARCH_PAGE,
	path: PROJECTS_FULL_PAGE_SEARCH_PATH,
	query: ['text?'],
	subproduct: 'townsquare-projects',
});
